<template>
  <div class="card">
    <header class="header-card">
      <p>{{ $t('ajoutEditContrat.informationsGenerales.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-3">
          <b-field :label="$t('ajoutEditContrat.informationsGenerales.code')"
                   :class="{'obligatoire' : !societeActive.masqueCodeContrat
                   || societeActive.masqueCodeContrat === ''}">
            <b-input v-model="contrat.code"
                     :disabled="societeActive.masqueCodeContrat !== null
                     && societeActive.masqueCodeContrat !== ''">
            </b-input>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('ajoutEditContrat.informationsGenerales.typeBail')"
                   class="obligatoire">
            <b-select v-model="contrat.type" expanded>
              <option v-for="typeContrat in listTypeContrat"
                      :key="typeContrat.code"
                      :value="typeContrat.code">
                {{ $t(typeContrat.libelle) }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('ajoutEditContrat.informationsGenerales.natureBail')"
                   class="obligatoire">
            <b-select v-model="contrat.natureId" expanded>
              <option v-for="type in contratNature"
                      :key="type.id"
                      :value="type.id">
                {{ type.libelle }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-3" v-if="agencesSelectionnees.length > 1">
          <selection-agence v-model="contrat.agenceId" obligatoire set-first-agence-find>
          </selection-agence>
        </div>
        <div class="column is-3" v-if="moduleSecteurActive">
          <secteur-select
            v-model="contrat.secteurId"
            :label="$t('ajoutEditContrat.informationsGenerales.secteur')"
            :type="secteurType"
            obligatoire/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { LISTE_TYPE_CONTRAT } from '@/configuration/baux/contrat/contratConf';
import secteurSelect from '@/components/commun/secteur/secteurSelect';
import { PATRIMOINE } from '@/configuration/parametrage/secteurConf';
import SelectionAgence from '@/components/general/selectionAgence';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'informationsGenerales',
  components: {
    SelectionAgence,
    secteurSelect,
  },
  props: {
    contrat: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      listTypeContrat: LISTE_TYPE_CONTRAT,
      secteurType: PATRIMOINE,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societeActive: 'societeActive',
      agencesSelectionnees: 'agenceActive',
    }),
    contratNature() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.contratNature);
    },
    moduleSecteurActive() {
      return this.parametresInterne(typesParametres.PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([
        typesParametres.PARAMETRES_KEYS.contratNature,
      ]);
      await this.loadParametresInterne([typesParametres.PARAMETRES_INTERNE_KEYS.moduleSecteur.key]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
